import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import './Sidebar.less';
import {
  ConfigProvider,
  Progress,
  Radio,
  Select,
  Slider,
  Switch,
  Upload,
  Input,
  Dropdown,
  Tooltip,
} from 'antd';
import { SDService, projectController } from '@/api';
import aip_model_anime from '@/assets/texture/aip_model_anime.png';
import aip_model_claymate from '@/assets/texture/aip_model_claymate.png';
import aip_model_claymate2 from '@/assets/texture/aip_model_claymate2.png';
import aip_model_fluffy from '@/assets/texture/aip_model_fluffy.png';
import aip_model_handai123 from '@/assets/texture/aip_model_handai123.png';
import aip_model_juggernautXL from '@/assets/texture/aip_model_juggernautXL.png';
import aip_model_labubu from '@/assets/texture/aip_model_labubu.png';
import aip_model_realistic from '@/assets/texture/aip_model_realistic.png';
import aip_model_yingshicheng from '@/assets/texture/aip_model_yingshicheng.png';
import aip_model_redhouse from '@/assets/texture/aip_model_redhouse.png';
import aip_model_monster from '@/assets/texture/aip_model_monster.png';

const styleImages = {
  aip_model_anime,
  aip_model_claymate,
  aip_model_claymate2,
  aip_model_fluffy,
  aip_model_handai123,
  aip_model_juggernautXL,
  aip_model_labubu,
  aip_model_realistic,
  aip_model_yingshicheng,
  aip_model_monster,
  aip_model_redhouse,
};
const { TextArea } = Input;
import Papa from 'papaparse';

import csvData from '@/config/texer_sd_settings.js'; // CRA/Vite 会自动处理为 URL
import toast from 'react-hot-toast';
import HoverButton from '@/components/HoverButton/HoverButton';
// 笔刷二种状态的默认值
const inpaintingStrengthStatusValue = {
  inpaint: 0.5,
  normal: 1,
};

export default forwardRef(function Sidebar(props, ref) {
  const [models, setModels] = useState([]);
  const [quality, setQuality] = useState('preview');
  const [prompt, setPrompt] = useState('');
  const [shape, setShape] = useState('depth');
  const [balance, setBalance] = useState('Balanced');
  const [controlWeight, setControlWeight] = useState(1);
  const [recordPage, setRecordPage] = useState(0);
  const [inpaintingStrength, setInpaintingStrength] = useState(0.5);
  const [showQulityMenu, setShowQulityMenu] = useState(false);
  const [showBanlanceMenu, setShowBanlanceMenu] = useState(false);
  const [showShapeMenu, setShowShapeMenu] = useState(false);
  const [isInpaint, setIsInpaint] = useState(false);
  const [lastSeed, setLastSeed] = useState(-1);

  const [seed, setSeed] = useState(false);
  const [thinkLoading, setThinkLoading] = useState(false);

  const [shapes, setShapes] = useState([
    {
      label: 'Shape(Depth)',
      key: 'depth',
    },
    {
      label: 'Detail(Normal)',
      key: 'normal',
    },
  ]);
  const [balances, setBalances] = useState([
    {
      label: 'Balance',
      key: 'Balanced',
    },
    {
      label: 'Prompt Biased',
      key: 'More User Biased',
    },
    {
      label: 'Structure Biased',
      key: 'More Control Net Biased',
    },
  ]);

  const [qualitys, setQualitys] = useState([
    {
      label: 'Preview',
      key: 'preview',
    },
    {
      label: 'Standard',
      key: 'stand',
    },
  ]);

  const [styleList, setStyleList] = useState([]);

  const [selectStyle, setSelectStyle] = useState(null);

  useImperativeHandle(ref, () => ({
    changeInpant(inpaint) {
      if (inpaint) {
        setInpaintingStrength(inpaintingStrengthStatusValue['inpaint']);

        console.log('inpaint', inpaintingStrengthStatusValue['inpaint']);
      } else {
        setInpaintingStrength(inpaintingStrengthStatusValue['normal']);
      }
      setIsInpaint(inpaint);
    },
    resetInpant() {
      inpaintingStrengthStatusValue['inpaint'] = 0.5;
      inpaintingStrengthStatusValue['normal'] = 1;
    },
    settingLastSeed(val) {
      console.log('settingLastSeed', seed, lastSeed, val);
      if (seed || lastSeed == -1) {
        setLastSeed(val);
      }
    },
  }));

  useEffect(() => {
    queryStyles();
  }, []);

  const queryStyles = async () => {
    const { data } = Papa.parse(csvData, {
      header: true,
      skipEmptyLines: true,
    });
    console.log('data', data);
    const list = await queryLoras();
    const modelList = await queryModelList();
    data.forEach((element, i) => {
      element.image = styleImages[element['key']];
      const loraName = element.loras.split(':');
      element.controlNets = element['control net'].split(',');

      const depth = element.controlNets[0];
      const normal = element.controlNets[1];

      const lora = list.find((item) => item.name === loraName);
      const depthModel = modelList.find((item) => item.includes(depth));
      const normalModel = modelList.find((item) => item.includes(normal));

      if (lora) {
        element.loras = loraName.replace(loraName, lora.alias);
      }
      if (depthModel) {
        element.controlNets[0] = depthModel;
      }
      if (normalModel) {
        element.controlNets[1] = normalModel;
      }
      if (i == 0) {
        const pv = localStorage.getItem('prompt_' + i);
        if (pv) {
          setPrompt(pv);
        } else {
        }
      }
      if (element.model === 'realisticvisionv51_v51vae') {
        element.show = true;
      } else {
        element.show = false;
      }
    });
    setSelectStyle(data[0]);
    setStyleList(data);
  };
  const queryLoras = async () => {
    try {
      const { raw_output } = await SDService.submitTaskAndResponse(
        '/sdapi/v1/loras',
        {},
        () => {},
        {},
        'GET',
      );
      return raw_output;
      // setModels(res.raw_output);
    } catch (error) {
      console.error(error);
    }
  };

  const queryModels = async () => {
    try {
      const { raw_output } = await SDService.submitTaskAndResponse(
        '/sdapi/v1/sd-models',
        {},
        () => {},
        {},
        'GET',
      );
      return raw_output;
    } catch (error) {
      console.error(error);
    }
  };

  const queryModelList = async () => {
    try {
      const { raw_output } = await SDService.submitTaskAndResponse(
        '/controlnet/model_list',
        {},
        () => {},
        {},
        'GET',
      );
      return raw_output.model_list;
    } catch (error) {
      console.error(error);
    }
  };

  // 生成
  const generate = async () => {
    if (!prompt) {
      return;
    }
    if (!selectStyle) {
      toast('Please choose style');
      return;
    }
    props.onGenerate({
      prompt:
        (selectStyle.loras ? `<lora:${selectStyle.loras}>,` : '') +
        (selectStyle.prompt ? selectStyle.prompt + ',' : '') +
        prompt,
      negative_prompt: selectStyle.neg_prompt,
      sampler_name: selectStyle.sampler,
      batch_size: 4,
      n_iter: 1,
      steps: 24,
      cfg_scale: selectStyle.cfg * 1,
      width: quality == 'preview' ? 512 : 1024,
      height: quality == 'preview' ? 512 : 1024,
      seed: seed ? -1 : lastSeed,
      refiner_checkpoint: '',
      refiner_switch_at: 0.56,
      tiling: false,
      enable_hr: false,
      save_detected_map: false,
      hr_upscaler: '',
      hr_sampler_name: selectStyle.sampler,
      hr_scale: 1.0,
      denoising_strength: inpaintingStrength,
      hr_second_pass_steps: 15,
      alwayson_scripts: {
        controlnet: {
          args: [
            {
              enabled: true,
              module: 'None',
              model: shape == 'depth' ? selectStyle.controlNets[0] : selectStyle.controlNets[1],
              weight: 1.0,
              resize_mode: 'Crop and Resize',
              pixel_perfect: false,
              control_mode: balance,
              processor_res: 512,
              threshold_a: 0.5,
              threshold_b: 0.5,
              guidance_start: 0.0,
              guidance_end: 1.0,
              hr_option: 'Both',
              input_mode: 'simple',
              lowvram: false,
              save_detected_map: false,
              use_preview_as_input: false,
              weight: controlWeight,
            },
          ],
        },
      },
    });
  };
  const propsUploadMesh = {
    name: 'file',
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const propsUploadTexture = {
    name: 'file',
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const getLabel = (items, key) => {
    const item = items.find((item) => item.key == key);
    if (item) {
      return item.label;
    }
    return '';
  };

  const think = async () => {
    if (!prompt) {
      return;
    }
    try {
      if (thinkLoading) {
        return;
      }
      setThinkLoading(true);
      const { code, data } = await projectController.completeText({
        body: {
          text: prompt,
        },
      });
      if (code == 0) {
        setPrompt(data);
      }
      setThinkLoading(false);
    } catch (error) {
      console.error(error);
      setThinkLoading(false);
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <div className="sidebar-content-wrapper">
          <div className="block1">
            <div className="buttons">
              <Upload
                beforeUpload={() => false}
                showUploadList={false}
                onChange={(info) => {
                  props.onUploadTexture(info.file);
                }}
                style={{ width: '100%' }}>
                <div className="upload-texture">Upload Texture</div>
              </Upload>
            </div>
            <div className="title">Styles</div>
          </div>
          <div className="styles">
            {styleList
              .filter((item) => item.show)
              .map((item) => {
                return (
                  <div
                    onClick={() => {
                      setSelectStyle(item);
                    }}
                    className={'style-item ' + (selectStyle == item ? 'checked' : '')}
                    key={item.name}>
                    <img src={item.image}></img>
                    <div className="name">{item.name}</div>
                  </div>
                );
              })}
          </div>
          <div className="block2">
            <Dropdown
              open={showShapeMenu}
              onClick={() => {
                setShowShapeMenu(!showShapeMenu);
              }}
              menu={{
                items: shapes,
                onClick: (v) => {
                  setShowShapeMenu(false);
                  if (v.key === 'depth') {
                    props.sendMessage('ContextManager', 'OnCmdExec', 'SetControlNetMode 0');
                  } else {
                    props.sendMessage('ContextManager', 'OnCmdExec', 'SetControlNetMode 1');
                  }
                  setShape(v.key);
                  console.log('change v', v);
                },
              }}
              trigger={['click']}>
              <div className="dropdown-select">
                <span className="dropdown-select-title">{getLabel(shapes, shape)}</span>
                <div className={'dropdown-select-icon ' + (showShapeMenu ? 'expand' : '')}></div>
              </div>
            </Dropdown>

            <Dropdown
              open={showBanlanceMenu}
              onClick={() => {
                setShowBanlanceMenu(!showBanlanceMenu);
              }}
              menu={{
                items: balances,
                onClick: (v) => {
                  setShowBanlanceMenu(false);
                  setBalance(v.key);
                  console.log('change v', v);
                },
              }}
              trigger={['click']}>
              <div className="dropdown-select">
                <span className="dropdown-select-title">{getLabel(balances, balance)}</span>
                <div className={'dropdown-select-icon ' + (showBanlanceMenu ? 'expand' : '')}></div>
              </div>
            </Dropdown>

            <Dropdown
              menu={{
                items: qualitys,
                onClick: (v) => {
                  setShowQulityMenu(false);
                  setQuality(v.key);
                  console.log('change v', v);
                },
              }}
              open={showQulityMenu}
              onClick={() => {
                setShowQulityMenu(!showQulityMenu);
              }}
              trigger={['click']}>
              <div className="dropdown-select">
                <span className="dropdown-select-title">{getLabel(qualitys, quality)}</span>
                <div className={'dropdown-select-icon ' + (showQulityMenu ? 'expand' : '')}></div>
              </div>
            </Dropdown>

            {/* <Select className="select" defaultValue={'shape'}>
        <Select.Option value="shape">Shape(Depth)</Select.Option>
      </Select> */}
            {/* <Select className="select" defaultValue={'banlance'}>
        <Select.Option value="banlance">Banlance</Select.Option>
      </Select>
      <Select className="select" defaultValue={'previewQuality'}>
        <Select.Option value="previewQuality">Preview Quality</Select.Option>
      </Select> */}
            <div className="inpainting">
              <div className="title">Control Weight</div>
              <Slider
                value={controlWeight}
                min={0}
                max={1}
                step={0.01}
                onChange={(value) => {
                  console.log('value', value);
                  setControlWeight(value);
                }}></Slider>
            </div>

            <div className="inpainting">
              <div className="title">Inpainting Strength</div>
              <Slider
                step={0.01}
                min={0}
                max={1}
                value={inpaintingStrength}
                onChange={(v) => {
                  if (isInpaint) {
                    inpaintingStrengthStatusValue['inpaint'] = v;
                  } else {
                    inpaintingStrengthStatusValue['normal'] = v;
                  }
                  setInpaintingStrength(v);
                }}></Slider>
            </div>
            <div className="text-area">
              <TextArea
                style={{ resize: 'none' }}
                onPaste={(e) => {
                  console.log('prompte', e.target.value);
                  const s = prompt.split(' ');
                  let value = e.target.value;
                  if (s.length > 75) {
                    value = s.slice(0, 75).join(' ');
                  }
                  setPrompt(value);
                  localStorage.setItem('prompt_' + recordPage, value);
                }}
                onChange={(e) => {
                  console.log('prompte', e.target.value);
                  const s = prompt.split(' ');
                  let value = e.target.value;
                  if (s.length > 75) {
                    value = s.slice(0, 75).join(' ');
                  }
                  setPrompt(value);
                  localStorage.setItem('prompt_' + recordPage, value);
                }}
                onKeyDown={(e) => {
                  console.log('onKeyDown', e);
                  e.stopPropagation();
                  props.sendMessage(
                    'ContextManager',
                    'OnCmdExec',
                    'captureAllKeyboardInputDisable',
                  );
                }}
                onKeyUp={(e) => {
                  console.log('onKeyUp', e);
                  e.stopPropagation();
                }}
                value={prompt}
                rows={4}
                placeholder="Prompt( eg.A 3D felt fiber house, soft smooth lighting, soft colors, 3D Blender render)..."
                className="prompt-input"></TextArea>

              <div
                className={'think ' + (!prompt ? 'disable' : '')}
                style={{ display: 'flex' }}
                onClick={() => {
                  think();
                }}>
                <div className={'icon ' + (thinkLoading ? 'loading' : '')}></div>
                <div>Think</div>
              </div>

              <div className="count">{prompt.split(' ').length}/75</div>
            </div>
            <div className="record">
              <span className="record-title">Record</span>
              {new Array(5).fill(0).map((item, i) => {
                return (
                  <div
                    onClick={() => {
                      setRecordPage(i);
                      const pv = localStorage.getItem('prompt_' + i);
                      if (pv) {
                        setPrompt(pv);
                      } else {
                        setPrompt('');
                      }
                    }}
                    className={'record-page ' + (recordPage === i ? 'active' : '')}
                    key={i}>
                    {i + 1}
                  </div>
                );
              })}
            </div>

            <div className="random">
              <span className="random-title">Random Seed</span>
              <Tooltip title="With the seed enabled, the inpainting will match the current result.">
                <div className="help"></div>
              </Tooltip>

              <div style={{ flex: 1 }}></div>
              <Switch
                value={seed}
                onChange={(v) => {
                  setSeed(v);
                }}></Switch>
            </div>
          </div>
        </div>
      </div>
      <div
        className={'generate-button ' + (!prompt ? 'disabled' : '')}
        onClick={() => {
          generate();
        }}>
        Generate Texture
      </div>
    </div>
  );
});
